<template>
  <span>
    <div class="page-level-functions">
      <action-button
        variant="success float-right ml-3"
        text="Guardar"
        i="fas fa-save"
        @click="handlerSave"
      />
      <router-link to="/permissions">
        <action-button
          variant="outline-success float-right ml-3"
          text="Regresar"
          i="fas fa-arrow-circle-left"
        />
      </router-link>
    </div>
    <hr class="page-level-functions-separator" />
    <section-title
      content="Información del Usuario"
      icon="fas fa-user"
      class="my-4 custom-section-title"
      container-class="bg-secondary-23"
    />
    <div class="mt-3">
      <b-tabs
        content-class="mt-3"
        active-nav-item-class="custom-tab custom-active-tab"
        nav-class="custom-nav-container"
        v-model="roleTabIndex"
      >
        <b-tab title="Usuarios" active>
          <div class="row mb-5">
            <div class="col-12 col-lg-3">
              <div class="d-flex font-13 justify-content-around mt-1">
                <a
                  class="text-success cursor-pointer"
                  @click="() => handlerSelectAll(false)"
                >
                  - Remover todas las seleccion
                </a>
                <a
                  class="text-success cursor-pointer"
                  @click="() => handlerSelectAll(true)"
                >
                  + Seleccionar todos
                </a>
              </div>
            </div>
            <div class="col-12 col-lg-9">
              <custom-input
                v-model="keyword"
                placeholder="Buscar usuario..."
                type="text"
                prepend-icon="fas fa-search"
                :prepend-icon-left="false"
                prepend-icon-type="extended-input-group"
                :prepend-icon-click="() => getUsers(keyword)"
              />
            </div>
          </div>
          <div v-for="(item, index) in users" :key="`permission-item-${index}`">
            <callout class="my-3" :has-toggle="false">
              <div class="d-flex justify-content-start align-items-center">
                <custom-check-box class="w-auto" v-model="item.selected" />
                <span class="color-black font-16 my-1 pt-1">
                  {{ item.name }}
                </span>
              </div>
            </callout>
          </div>
        </b-tab>
        <b-tab title="Roles">
          <div class="row mb-5">
            <div class="col-12 col-lg-3">
              <div class="d-flex font-13 justify-content-around mt-1">
                <a
                  class="text-success cursor-pointer"
                  @click="() => handlerSelectAllRoles(false)"
                >
                  - Remover todas las seleccion
                </a>
                <a
                  class="text-success cursor-pointer"
                  @click="() => handlerSelectAllRoles(true)"
                >
                  + Seleccionar todos
                </a>
              </div>
            </div>
            <div class="col-12 col-lg-9">
              <custom-input
                v-model="roleName"
                placeholder="Buscar role..."
                type="text"
                prepend-icon="fas fa-search"
                :prepend-icon-left="false"
                prepend-icon-type="extended-input-group"
                :prepend-icon-click="() => getRoles(roleName)"
              />
            </div>
          </div>
          <div
            v-for="(item, index) in roles"
            :key="`permission-role-item-${index}`"
          >
            <callout class="my-3" :has-toggle="false">
              <div class="d-flex justify-content-start align-items-center">
                <custom-check-box class="w-auto" v-model="item.selected" />
                <span class="color-black font-16 my-1 pt-1">
                  {{ item.name }}
                </span>
              </div>
            </callout>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </span>
</template>
<script>
import ActionButton from 'ActionButton';
import SectionTitle from '@/components/common/SectionTitle';
import Callout from '@/components/common/callout/View';
import alertMixin from '../../mixins/alert.mixin';
import { CustomCheckBox } from '@/components/common';
import CustomInput from 'CustomInput';

import {
  getUsers,
  removeUsers,
  getRoles,
  removeRoles,
} from '@/modules/permissions/api';

const TABS = {
  USERS: 0,
  ROLES: 1,
};

export default {
  name: 'PermissionDetail',
  components: {
    ActionButton,
    SectionTitle,
    Callout,
    CustomCheckBox,
    CustomInput,
  },
  mixins: [alertMixin],
  data: () => ({
    page: {
      icon: 'fas fa-list',
      title: 'Manejo de Referidos y Equipos',
      routes: ['Asistencia Tecnológica', 'Manejo de Referidos y Equipos'],
    },
    users: [],
    roles: [],
    keyword: '',
    roleName: '',
    roleTabIndex: TABS.USERS,
  }),
  computed: {
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'at' }),
        },
      ];
    },
    permissionId() {
      return Number(this.$route.params.permissionId) || null;
    },
    isRoleTab() {
      return this.roleTabIndex === TABS.ROLES;
    },
  },
  async created() {
    this.init();
  },
  methods: {
    async init() {
      await Promise.all([this.getUsers(), this.getRoles()]);
    },
    async getUsers(keyword) {
      try {
        const { data } = await getUsers(this.permissionId, { keyword });
        this.users = data;
      } catch (error) {
        this.ShowToast('Error', 'Ha ocurrido un error', 'error');
      }
    },
    async getRoles(keyword) {
      try {
        const { data } = await getRoles(this.permissionId, { keyword });
        this.roles = data;
      } catch (error) {
        this.ShowToast('Error', 'Ha ocurrido un error', 'error');
      }
    },
    async handlerSave() {
      try {
        if (this.isRoleTab) {
          await this.handlerSaveRole();
        } else {
          await this.handlerSaveUser();
        }
        this.ShowToast(
          'Alerta',
          `Se han guardado los cambios correctamente`,
          'success'
        );
        await this.init();
      } catch (error) {
        this.ShowToast('Error', 'Ha ocurrido un error', 'error');
      }
    },
    async handlerSaveUser() {
      const unSelectedUsers = this.users.filter((user) => !user.selected);
      const users = unSelectedUsers.map((user) => user.id);
      await removeUsers(this.permissionId, users);
    },
    async handlerSaveRole() {
      const unSelectedRoles = this.roles.filter((role) => !role.selected);
      const roles = unSelectedRoles.map((role) => role.id);
      await removeRoles(this.permissionId, roles);
    },
    handlerSelectAll(selected) {
      this.users = this.users.map((user) => ({ ...user, selected }));
    },
    handlerSelectAllRoles(selected) {
      this.roles = this.roles.map((role) => ({ ...role, selected }));
    },
  },
};
</script>
<style lang="scss">
.extended-input-group {
  & > span {
    background-color: #2db782;
    color: white;
    border: 1px solid #2db782;
  }
}
</style>
